var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavegationBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navegation_icon_voltar",
    "data-name": "navegation/icon/voltar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_989",
    "data-name": "Ret\\xE2ngulo 989",
    width: 27,
    height: 27,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-arrow_back",
    "data-name": "Icon material-arrow_back",
    d: "M24,13.875H10.309L16.6,7.586,15,6,6,15l9,9,1.586-1.586-6.278-6.289H24Z",
    transform: "translate(-1 -1)",
    fill: "#3c3c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavegationBack);
export default __webpack_public_path__ + "static/media/navegation-back.57f27776d079ece05a3e984ec56c5f97.svg";
export { ForwardRef as ReactComponent };